import type React from "react";
import type { LucideIcon } from "lucide-react";
import type { DimensionId } from "@benyishiguang/ui-foundation";
import { DIM } from "@/features/growth/dimensions";
import { cn } from "@/lib/utils";
export const EmptyState: React.FC<{
	icon: LucideIcon;
	text: string;
	title: string;
	actionLabel?: string;
	className?: string;
	tone?: DimensionId;
	onAction?: () => void;
}> = ({ actionLabel, className, icon: Icon, onAction, text, title, tone = "aware" }) => {
	const dimension = DIM[tone];
	return (
		<article
			className={cn("friendly-empty", className)}
			style={
				{
					"--empty-dim": dimension.color,
					"--empty-soft": dimension.soft,
					"--empty-deep": dimension.deep,
				} as React.CSSProperties
			}
		>
			<div className="friendly-empty-icon">
				<Icon size={20} strokeWidth={2.2} />
			</div>
			<div className="friendly-empty-copy">
				<strong>{title}</strong>
				<p>{text}</p>
			</div>
			{actionLabel && onAction && (
				<button className="friendly-empty-action" onClick={onAction} type="button">
					<Icon size={18} />
					{actionLabel}
				</button>
			)}
		</article>
	);
};
